import React, { useEffect } from 'react';
import AdvisoryFlowLoading from '../../../../flows/src/components/ui/advisory-flow/components/app-shell/AdvisoryFlowLoading';
import useUuid from '../../../../common/src/hooks/useUuid';
import useStartBikmoOfferFlow from '../../hooks/bikmo/useStartBikmoOfferFlow';

const BikmoOffers: React.FC = () => {
  const uuid = useUuid();
  const startFlow = useStartBikmoOfferFlow();

  useEffect(() => {
    startFlow(uuid);
  }, []);

  return <AdvisoryFlowLoading />;
};

export default BikmoOffers;
